<template>
  <div class="time-progress">
    <div class="time-line-header">
      <div class="header-label"></div>
      <div class="header-item-area">
        <div class="header-item"
             v-for="time in 13"
             :key="time">
          {{(time > 5 ? '' : '0') + '' + (time - 1) * 2}}:00
        </div>
      </div>
    </div>
    <div class="progress-area">
      <div class="day-label-area">
        <div class="day-label"
             :class="[item.active ? 'active' : 'disabled']"
             v-for="(item, index) in dayList"
             :key="index">{{item.label}}</div>
      </div>
      <div class="day-line-area">
        <div class="day-line"
             :class="[item.active ? 'active' : 'disabled']"
             v-for="(item, index) in dayList"
             :key="index">
          <div class="time-item-area">
            <div :class="['time-item', timeClass[time]]"
                 v-for="(time, tIndex) in item.dayTime"
                 :key="tIndex"></div>
          </div>
        </div>
        <div class="day-line-draw"
             @mouseout="rangeOut"
             @mouseover="rangeHover"
             @mousedown="startChoose"
             @mousemove="choosing"
             @mouseup="finishChoose"></div>
        <div class="day-line-undraw"
             :style="'top: ' + unDrawInfo.top.top + 'px; height: ' + unDrawInfo.top.height + 'px;'"
             @mouseup="finishChoose"
             @mouseout="rangeOut"
             @mouseover="rangeHover"
             @mousemove="rangeHover"></div>
        <div class="day-line-undraw"
             :style="'top: ' + unDrawInfo.bottom.top + 'px; height: ' + unDrawInfo.bottom.height + 'px;'"
             @mouseup="finishChoose"
             @mouseout="rangeOut"
             @mouseover="rangeHover"
             @mousemove="rangeHover"></div>
        <div class="time-range-tips"
             :class="{hide: hoverInfo.hide}"
             :style="{ left: hoverInfo.left + 'px', top: hoverInfo.top + 'px'}">
          <span class="week-text">{{hoverInfo.weekDay}}</span>
          <span>{{hoverInfo.startTime}}</span>
          <span class="split-symbol">-</span>
          <span>{{hoverInfo.endTime}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    options: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      readOnly: false,
      dayList: [{
        label: '周一',
        active: false,
        // 时间选中状态，0：未选中，1：选择中，2：已选中
        dayTime: []
      }, {
        label: '周二',
        active: false,
        dayTime: []
      }, {
        label: '周三',
        active: false,
        dayTime: []
      }, {
        label: '周四',
        active: false,
        dayTime: []
      }, {
        label: '周五',
        active: false,
        dayTime: []
      }, {
        label: '周六',
        active: false,
        dayTime: []
      }, {
        label: '周日',
        active: false,
        dayTime: []
      }],
      timeClass: {
        0: 'unactive',
        1: 'choosing',
        2: 'choosed'
      },
      startFlag: false,
      unDrawInfo: {
        top: {
          top: 0,
          height: 190
        },
        bottom: {
          top: 0,
          height: 0
        }
      },
      hoverInfo: {
        left: 0,
        top: 0,
        hide: true,
        weekDay: '周一',
        startTime: '12:00',
        endTime: '15:00'
      }
    }
  },
  computed: {},
  created () {
    this.dayList.forEach((item) => {
      item.dayTime = this.getTimeRangeByValue();
    });
  },
  beforeDestroy () {
    document.removeEventListener('mouseup', this.finishChoose);
  },
  mounted () {
    document.addEventListener('mouseup', this.finishChoose);
  },
  methods: {
    rangeHover (e) {
      this.processTips(e);
    },
    rangeOut () {
      this.hoverInfo.hide = true;
    },
    processTips (e) {
      this.hoverInfo.left = e.offsetX - 60;
      this.hoverInfo.top = e.offsetY - 35;
      const hoverRow = parseInt(e.offsetY / 27);
      const hoverColumn = parseInt(e.offsetX / 15);
      this.hoverInfo.weekDay = this.dayList[hoverRow].label;
      const dayTime = this.dayList[hoverRow].dayTime;
      this.hoverInfo.hide = dayTime[hoverColumn] !== 2;
      let startIndex = hoverColumn;
      let endIndex = hoverColumn;
      for (let i = hoverColumn; i < 48; i++) {
        if (dayTime[i] === 2) {
          endIndex = i;
        } else {
          break;
        }
      }
      for (let i = hoverColumn; i >= 0; i--) {
        if (dayTime[i] === 2) {
          startIndex = i;
        } else {
          break;
        }
      }
      this.hoverInfo.startTime = this.getTipsTimeStr(startIndex * 0.5);
      this.hoverInfo.endTime = this.getTipsTimeStr((endIndex + 1) * 0.5);
    },
    getTipsTimeStr (number) {
      let hour = parseInt(number);
      let minute = (number % 1) * 60;
      return (hour > 9 ? hour : '0' + hour) + ':' + (minute > 9 ? minute : '0' + minute);
    },
    startChoose (e) {
      if (this.rangType === 1) {
        return;
      }
      const el = e.target;
      if (el.className === 'day-line-undraw') {
        return;
      }
      if (this.startFlag) {
        this.startFlag = false;
        this.computDayList(2);
        return;
      }
      this.startFlag = true;
      // 时间块高度为27
      this.startRow = parseInt(e.offsetY / 27);
      // 时间块宽度15
      this.startColumn = parseInt(e.offsetX / 15);
      if (this.dayList[this.startRow].dayTime[this.startColumn] === 2) {
        this.choosingValue = 0;
      } else {
        this.choosingValue = 1;
      }
    },
    choosing (e) {
      // 如果当前未开始选择，则判断当前是否有选中的时间点，进行弹框提示
      if (!this.startFlag) {
        this.processTips(e);
        return;
      }
      const el = e.target;
      if (el.className === 'day-line-undraw') {
        return;
      }
      // 时间块高度为27
      this.lastRow = parseInt(e.offsetY / 27);
      // 时间块宽度15
      this.lastColumn = parseInt(e.offsetX / 15);
      this.computDayList(this.choosingValue);
    },
    finishChoose (e) {
      if (!this.startFlag) {
        return;
      }
      this.$nextTick(() => {
        this.computDayList(2);
      });
      this.startFlag = false;
    },
    computDayList (value = 0) {
      let dayList = [...this.dayList];
      if (value === 2) {
        for (let i = 0; i < dayList.length; i++) {
          for (let j = 0; j < dayList[i].dayTime.length; j++) {
            if (dayList[i].dayTime[j] === 1) {
              dayList[i].dayTime[j] = value;
            }
          }
        }
        this.$emit('choosed', this.getResult(dayList));
      } else {
        let minRow = Math.min(this.startRow, this.lastRow);
        let maxRow = Math.max(this.startRow, this.lastRow);
        let minColumn = Math.min(this.startColumn, this.lastColumn);
        let maxColumn = Math.max(this.startColumn, this.lastColumn);
        for (let i = 0; i < dayList.length; i++) {
          if (i >= minRow && i <= maxRow && dayList[i].active) {
            for (let j = 0; j < dayList[i].dayTime.length; j++) {
              if (j >= minColumn && j <= maxColumn) {
                dayList[i].dayTime[j] = value;
              }
            }
          }
        }
      }
      this.dayList = dayList;
    },
    getResult (dayList = []) {
      let result = [];
      for (let i = 0; i < dayList.length; i++) {
        if (dayList[i].active) {
          // 星期日-星期六，后台日期索引为：0 - 6
          const dayIndex = i === 6 ? 0 : (i + 1);
          let firstIndex = -1;
          let lastIndex = -1;
          for (let j = 0; j < dayList[i].dayTime.length; j++) {
            // 时间段开始循环时，判断当前节点是否被选中
            if (dayList[i].dayTime[j] === 2) {
              // 如果当前节点被选中，并且起始索引为-1，则记录起始索引为当前索引值
              if (firstIndex === -1) {
                firstIndex = j;
              }
              // 只要节点被选中，则记录结束索引为当前索引
              lastIndex = j;
            } else if (firstIndex !== -1 && lastIndex !== -1) {
              // 如果记录未被选中，则判断起始和结束索引是否有值
              // 1、如果有值，则表示有一个时间段待记录，将该时间段记录完成
              ///2、重置起始和结束索引，待下次被选中的节点继续记录索引值
              result.push({
                startTime: this.getTimeStr(firstIndex * 0.5),
                endTime: this.getTimeStr((lastIndex + 1) * 0.5),
                weekNum: dayIndex
              });
              firstIndex = -1;
              lastIndex = -1;
            }
            // 当前日期循环结束后，判断起始和结束索引是否有值，有值的情况下进行时间段封装
            // 该处理逻辑是为了确保结束索引为最后一个节点（24:00），此情况无法进入上面的else封装时间段，则需要在循环结束时再次进行封装
            if (j >= dayList[i].dayTime.length - 1 && firstIndex !== -1 && lastIndex !== -1) {
              result.push({
                startTime: this.getTimeStr(firstIndex * 0.5),
                endTime: this.getTimeStr((lastIndex + 1) * 0.5),
                weekNum: dayIndex
              });
            }
          }
        }
      }
      return result;
    },
    getTimeStr (number) {
      let hour = parseInt(number);
      let minute = (number % 1) * 60;
      let second = '00';
      return (hour > 9 ? hour : '0' + hour) + ':' + (minute > 9 ? minute : '0' + minute) + ':' + second;
    },
    getTimeIndex (timeStr, diff) {
      let hour = parseInt(timeStr.split(':')[0]) * 2;
      let minute = parseInt(parseInt(timeStr.split(':')[1]) / 30);
      const index = hour + minute - diff;
      return index;
    },
    setDay (dateData = {
      rangType: 2,
      startDate: new Date().toLocaleDateString(),
      endDate: new Date().toLocaleDateString(),
      dayTime: []
    }, readOnly = false) {
      this.readOnly = readOnly;
      this.rangType = dateData.rangType;
      this.dayList.forEach((item) => {
        item.active = false;
        item.dayTime = this.getTimeRangeByValue();
      });
      let diff = parseInt(new Date(dateData.endDate) - new Date(dateData.startDate)) / 8.64e7;
      if (diff < 0) {
        return;
      }
      let localTimeRange = {};
      if (dateData.dayTime && dateData.dayTime.length) {
        dateData.dayTime.forEach((item) => {
          if (!localTimeRange[item.weekNum] || !localTimeRange[item.weekNum].length) {
            localTimeRange[item.weekNum] = [];
          }
          const startIndex = this.getTimeIndex(item.startTime, 0);
          const lastIndex = this.getTimeIndex(item.endTime, 0);
          for (let i = startIndex; i < lastIndex; i++) {
            localTimeRange[item.weekNum].push(i);
          }
        });
      }
      for (let i = 0; i <= diff; i++) {
        if (i > 7) {
          break;
        }
        // 将页面展示的dayIndex转化成后台对应的weekNum
        // 页面展示顺序：星期一、星期二、星期三、星期四、星期五、星期六、星期日
        // 后台保存顺序：星期日、星期一、星期二、星期三、星期四、星期五、星期六
        const weekNum = new Date(new Date(dateData.startDate).getTime() + i * 8.64e7).getDay();
        // 页面展示的顺序是：星期一到星期日为 0 - 6
        let dayIndex = weekNum === 0 ? 6 : weekNum - 1;
        if (dayIndex < this.dayList.length) {
          this.dayList[dayIndex].active = true;
          if (this.rangType === 1) {
            this.dayList[dayIndex].dayTime = this.getFullTimeRange();
          } else {
            this.dayList[dayIndex].dayTime = this.getTimeRangeByValue(localTimeRange[weekNum]);
          }
        }
      }
      this.computUnDrawArea();
      if (!dateData.dayTime || !dateData.dayTime.length) {
        this.$emit('choosed', this.getResult(this.dayList));
      }
    },
    computUnDrawArea () {
      this.unDrawInfo = {
        top: {
          top: 0,
          height: 0
        },
        bottom: {
          top: 0,
          height: 0
        }
      };
      if (this.readOnly) {
        this.unDrawInfo.top.height = 190;
        return;
      }
      let topFirstUnactive = -1;
      let topLastUnactive = -1;
      let firstActive = -1;
      let lastActive = -1;
      let bottomFirstUnactive = -1;
      let bottomLastUnactive = -1;
      this.dayList.forEach((item, index) => {
        if (item.active) {
          if (firstActive === -1) {
            firstActive = index;
          }
          lastActive = index;
        } else {
          if (firstActive === -1) {
            if (topFirstUnactive === -1) {
              topFirstUnactive = index;
            }
            topLastUnactive = index;
          } else {
            if (bottomFirstUnactive === -1) {
              bottomFirstUnactive = index;
            }
            bottomLastUnactive = index;
          }
        }
      });
      this.unDrawInfo.top.top = topFirstUnactive * 27;
      this.unDrawInfo.top.height = (topLastUnactive - topFirstUnactive + 1) * 27;
      this.unDrawInfo.bottom.top = bottomFirstUnactive * 27;
      this.unDrawInfo.bottom.height = (bottomLastUnactive - bottomFirstUnactive + 1) * 27;
      if (topFirstUnactive === -1) {
        this.unDrawInfo.top.top = 0;
        this.unDrawInfo.top.height = 0;
      }
      if (bottomFirstUnactive === -1) {
        this.unDrawInfo.bottom.top = 0;
        this.unDrawInfo.bottom.height = 0;
      }
    },
    getTimeRangeByValue (value = []) {
      let dayTime = [];
      for (let j = 0; j < 48; j++) {
        if (value.indexOf(j) !== -1) {
          dayTime.push(2);
        } else {
          dayTime.push(0);
        }
      }
      return dayTime;
    },
    getFullTimeRange () {
      let dayTime = [];
      for (let j = 0; j < 48; j++) {
        dayTime.push(2);
      }
      return dayTime;
    }
  }
}

</script>
<style lang="scss">
@import "~@src/common/assets/style/mixin";
.time-progress {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  .time-line-header {
    margin-left: 20px;
    height: 20px;
    display: flex;

    .header-label {
      width: 45px;
    }

    .header-item-area {
      flex: 1;
      display: flex;

      .header-item {
        width: 36px;
        margin-left: 24px;
        font-size: 14px;
        text-align: center;
        @include set_theme_color(color, font-inactive-color);

        &:first-child {
          margin-left: 0;
        }
      }
    }
  }

  .progress-area {
    flex: 1;
    margin-top: 20px;
    padding: 0 20px;
    display: flex;

    .day-label-area {
      width: 60px;
      font-size: 14px;
      color: #666666;
      display: flex;
      flex-direction: column;

      .day-label {
        flex: 1;
        display: flex;
        align-items: center;
        @include set_theme_color(color, font-inactive-color);
        &.active {
          // @include set_theme_color(color, font-active-color);
          @include set_theme_color(color, main-theme-color);
        }
      }
    }

    .day-line-area {
      // 不再使用flex布局确定大小，固定该区域大小，便于计算选中区域
      // 该布局下，每行高度为27px
      // 时间块宽度为15px
      // flex: 1;
      width: 720px;
      height: 190px;
      display: flex;
      flex-direction: column;
      border-left: 1px solid #cccccc;
      border-bottom: 1px solid #cccccc;
      position: relative;
      cursor: pointer;

      .time-range-tips {
        position: absolute;
        background-color: #ffffff;
        color: #666666;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 120px;
        height: 20px;
        border-radius: 3px;
        left: 0;
        font-size: 13px;

        &.hide {
          top: -100px !important;
        }

        &:before {
          position: absolute;
          content: " ";
          border-color: #ffffff transparent transparent transparent;
          border-width: 5px;
          border-style: solid;
          left: 50%;
          bottom: -10px;
          transform: translateX(-50%);
        }

        .week-text {
          margin-right: 5px;
          color: #475892;
          font-weight: bold;
        }

        .split-symbol {
          margin: 0 3px;
        }
      }

      .day-line-draw {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        cursor: pointer;
      }

      .day-line-undraw {
        position: absolute;
        cursor: no-drop;
        width: 100%;
      }

      .day-line {
        height: 27px;
        display: flex;
        border-top: 1px solid #cccccc;

        &.active {
          background-color: #ffffff;
          cursor: pointer;
        }

        &.disabled {
          cursor: no-drop;
        }

        .time-item-area {
          flex: 1;
          height: 100%;
          display: flex;

          .time-item {
            width: 15px;
            &.unactive {
              background-color: #505563;
            }
            &.choosed {
              // background-color: #475892;
              @include set_theme_color(background-color, main-theme-color);
            }

            &.choosing {
              background-color: #6674a6;
            }

            &:nth-child(even) {
              border-right: 1px solid #cccccc;
            }

            &:nth-child(odd) {
              border-left: 1px solid rgba(255, 255, 255, 0);
            }
          }
        }
      }

      // 仅针对edge
      @supports (-ms-ime-align: auto) {
        .day-line {
          border-radius: 1px;
        }
      }
    }
  }

  // 仅针对edge
  @supports (-ms-ime-align: auto) {
    .progress-area {
      margin-top: 16px;
      padding: 2px 20px;
    }
  }
}
</style>
